module.exports = __webpack_public_path__ + "media/interview1.865aa3ee.mp3";